import { render, staticRenderFns } from "./reportPathology.vue?vue&type=template&id=19ba11c4&scoped=true"
import script from "./reportPathology.vue?vue&type=script&lang=js"
export * from "./reportPathology.vue?vue&type=script&lang=js"
import style0 from "./reportPathology.vue?vue&type=style&index=0&id=19ba11c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ba11c4",
  null
  
)

export default component.exports